import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailHistoryComponent } from './components/email-history/email-history.component';
import { SendEmailComponent } from './components/send-email/send-email.component';
import { EmailTemplateComponent } from './components/email-template/email-template.component';

interface CommunicationTab {
  id: string;
  name: string;
}

@Component({
  selector: 'app-comunications',
  standalone: true,
  imports: [
    CommonModule,
    EmailHistoryComponent,
    SendEmailComponent,
    EmailTemplateComponent
  ],
  templateUrl: './comunications.component.html',
  styleUrl: './comunications.component.css'
})
export class ComunicationsComponent {
  tabs: CommunicationTab[] = [
    { id: 'history', name: 'Historial de Emails' },
    { id: 'send', name: 'Enviar Email' },
    { id: 'templates', name: 'Plantillas de Email' }
  ];

  activeTabId: string = 'history';

  onTabChange(tabId: string): void {
    this.activeTabId = tabId;
  }

  isActiveTab(tabId: string): boolean {
    return this.activeTabId === tabId;
  }
}
